<template>
  <div id="app">
    <router-view/>
    <audio ref="myAudio" class="bacAudio" :src="audioUrl" loop controls preload="auto"></audio>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      audioUrl: require('./assets/myvideo.mp3')
    }
  }
}
</script>

<style>
  #app{
    width: 100%;
    height: 100%;
    -webkit-overflow-scrolling: touch;
  }
  html, body, div, p, h1, h2, h3, h4, h5, ol, ul, li, dl, dt, dd, form, input, textarea, select, span, table, tr, td, img {
    margin: 0;
    padding: 0;
    border: 0;
  }
  html, body {
    background:rgba(0,0,0,0.94);
    color: rgba(122,122,122,1);
    font-family: "HYQiHei-EES", "Hiragino Sans GB", "Noto Sans", "MicrosoftYahei", "Helvetica Neue", "Arial";
    user-select: none;
    -webkit-user-select: none;
    -webkit-touch-callout:none;
    -webkit-font-smoothing: antialiased;
    font-size: 0.32rem;
    color: rgba(122,122,122,1);
    width: 100%;
    height: 100%;
    margin: 0 auto;
    -webkit-overflow-scrolling: touch;
    /*height: 100%*/
  }

  body{
    -moz-user-select:none;/*火狐*/
    -webkit-user-select:none;/*webkit浏览器*/
    -ms-user-select:none;/*IE10*/
    user-select:none;
  }
  *:focus, *:hover {
    outline: none;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    -webkit-tap-highlight-color: transparent;
  }
  :not(input,textarea) {
    -webkit-touch-callout: none;
    -webkit-user-select: element;
    user-select: element;
  }
  input, textarea {
    box-shadow:0px 0px 0px rgba(0,0,0,0);
    -webkit-appearance: none;
  }
  input, textarea {
    outline: none;
    border: none;
    border-radius: 0;
  }
  input::-moz-focus-inner,input::-webkit-focus-inner,input::focus-inner {
    border: 0;
  }
  textarea {
    resize: none;
  }
  ul, ol, li {
    list-style: none;
  }
  a {
    text-decoration: none;
    color: #333;
    outline: none;
  }
  a,input{
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    -webkit-tap-highlight-color: transparent;
  }
  a:focus, input:focus {
    outline: 0;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    -webkit-tap-highlight-color: transparent;
  }

  *{
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    -webkit-tap-highlight-color: transparent;
  }

  @font-face{
    font-family: HYSongYunLangHeiW; /*这里是说明调用来的字体名字*/
    src: url(./assets/HYSongYunLangHeiW.ttf); /*这里是字体文件路径*/
  }

  .bacAudio{
    position: fixed;
    top: 0;
    left: 0;
    width: 0;
    height: 0;
    visibility: hidden;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue